export function voiceModeChangeNotifyMessage(
    state = {
        status: false,
    }, action){

    switch(action.type){
        case 'VOICE_MODE_CHANGE':{
            return Object.assign({}, state, action.payload);
        }
        default:{
            return state;
        }
    }
}